import { FC } from "react";
import SnowflakeLogo from "../../../../../../../assets/logos/integrations/snowflake.svg";
import { ProviderConnection } from "@/components/pages/integrations/components/common/types/common";

const logos: Map<ProviderConnection, any> = new Map([
  ["snowflake", SnowflakeLogo],
]);

interface ProviderConnectionLogoProps {
  type: ProviderConnection;
  width?: number;
}

export const ProviderConnectionLogo: FC<ProviderConnectionLogoProps> = ({
  type,
  width,
}) => {
  return <img src={logos.get(type)} alt={type} width={width} />;
};
